export const CONTACT_FORM_SETTINGS_CONFIG = {
  custom_get_in_touch_form_title: {
    key: "custom_get_in_touch_form_title",
    label: "Form Title",
    tooltipText: "This text will appear at the top of the form.",
    placeholder: "Enter Form Title",
  },
  custom_get_in_touch_form_cta: {
    key: "custom_get_in_touch_form_cta",
    label: "Submit Form Button text",
    tooltipText:
      "This text will appear on the button through which the users will submit the form. Make it actionable and drive submissions!",
    placeholder: "Enter Button Text",
  },
  post_interest_url: {
    key: "post_interest_url",
    label: "Submit Form Button URL",
    placeholder: "Enter Button URL",
    tooltipText:
      "The user will be redirected to this URL once they click on the submit button. If left blank, the form will simply submit and close without any redirection.",
  },
};

export const CONTACT_FORM_SETTINGS_KEY = "getin_touch_attributes";

export const CONTACT_FORM_INITIAL_VALUES = {
  custom_get_in_touch_form_title: "Get in touch",
  custom_get_in_touch_form_cta: "Send Message",
};
